<template>
    <div class="navBottom flex flex-j-c flex-a-c font-18">
        <div class="content w-1200 flex flex-col">
            <div class="flex flex-a-c top">
                <div>
                    <img src="../assets/img/logo.png" height="47" width="200" alt="">
                    <div class="mt-8">
                        <span @click="$router.push('/pc-en/about-us')">About</span>
                        <span class="ml-6" @click="$router.push('/pc-en/product-center')">Products</span>
                        <span class="ml-6" @click="$router.push('/pc-en/customized-services')">Services</span>
                        <span class="ml-6"
                              @click="$router.push('/pc-en/information-center/product-catalog')">Data</span>
                    </div>
                </div>
                <div class="code flex flex-col flex-a-c">
                    <img src="../assets/img/qrcode.jpg" alt="" style="width: 124px;height: 124px;">
                    <div class="mt-2">
                        <div>scan and follow the</div>
                        <div>wechat official account</div>

                    </div>
                </div>
                <div>
                    <div>consumer hotline</div>
                    <div class="font-24 mt-2">0755-26886631</div>
                    <div class="mt-3">email:hpbiotech@huapua.com</div>
                    <div class="mt-2">company address：Chiwan Petroleum Building, No. 6, Chiwan 5th Road, Chiwan
                        Community, Zhaoshang Street, Nanshan District, Shenzhen.
                    </div>
                </div>
            </div>
            <div class="flex flex-j-c flex-a-c bottom">
                <div>Shenzhen Huapua Biomedical Co., Ltd.</div>
                <div style="margin-left: 50px;">Guangdong ICP No. 2020086656-1</div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'navBottom',
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},

    }
</script>
<style scoped lang="scss">
    .navBottom {
        width: 100%;
        height: 360px;
        background: #F7F9FA;
        border-radius: 8px;

        .content {
            .top {
                height: 246px;
                position: relative;

                .code {
                    width: 470px;
                }
            }

            .top::after {
                content: '';
                left: 0;
                bottom: 0;
                position: absolute;
                width: 100%;
                height: 1px;
                background-color: #C3C8CA;
            }

            .bottom {
                height: 113px;
            }
        }
    }
</style>
